import { appConfig } from '@/shared/config/app-config';
import { getEncodedData } from '@/shared/lib/cognito-threat-protection';

export type SignUpErrorCode = 'EMAIL_IN_USE' | 'WEAK_PASSWORD' | 'UNKNOWN';

export type SignUpResult = { ok: true; returnUrl?: string } | { ok: false; code: SignUpErrorCode };

export async function signUpWithEmail(input: {
    email: string;
    password: string;
    signUpData?: string;
}): Promise<SignUpResult> {
    let response: Response;
    try {
        response = await fetch(`${appConfig.apiUrl}/auth/sign-up`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: input.email,
                password: input.password,
                encodedData: getEncodedData(input.email),
                ...(input.signUpData && { signUpData: input.signUpData }),
            }),
        });
    } catch {
        return { ok: false, code: 'UNKNOWN' };
    }

    if (response.ok) {
        const data = (await response.json().catch(() => null)) as { returnUrl?: string } | null;
        return { ok: true, returnUrl: data?.returnUrl };
    }

    if (response.status === 409) {
        return { ok: false, code: 'EMAIL_IN_USE' };
    }
    if (response.status === 422) {
        return { ok: false, code: 'WEAK_PASSWORD' };
    }
    return { ok: false, code: 'UNKNOWN' };
}
